import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import App from './App.vue'
import routers from './routers'
import dateService from './services/common/dateService'

import { Header, Button, Cell, CellSwipe, DatetimePicker, InfiniteScroll, Navbar, Popup, Search, Switch, Swipe, SwipeItem,
  Spinner, TabItem, TabContainerItem, TabContainer, Actionsheet, Indicator, MessageBox, Loadmore } from 'mint-ui'

Vue.prototype.env = 'pro'
Vue.config.productionTip = false

Vue.use(InfiniteScroll)
Vue.component(Header.name, Header)
Vue.component(Button.name, Button)
Vue.component(Cell.name, Cell)
Vue.component(CellSwipe.name, CellSwipe)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(Navbar.name, Navbar)
Vue.component(Popup.name, Popup)
Vue.component(Switch.name, Switch)
Vue.component(Search.name, Search)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.component(Spinner.name, Spinner)
Vue.component(TabItem.name, TabItem)
Vue.component(TabContainerItem.name, TabContainerItem)
Vue.component(TabContainer.name, TabContainer)
Vue.component(Actionsheet.name, Actionsheet)
Vue.component(Loadmore.name, Loadmore)

Vue.use(VueRouter)
Vue.use(VueResource)

// 挂载全局方法
Vue.prototype.$Vue = Vue
Vue.prototype.MessageBox = MessageBox
Vue.prototype.Indicator = Indicator
Vue.prototype.$date = dateService
Vue.prototype.$date.format = dateService.format

const router = new VueRouter({
  routes: routers
})

new Vue({
  el: '#app',
  router,
  render: h => h(App),
}).$mount('#app')
